export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('datamgmt-state')
    if (serializedState === null) {
      return undefined
    }
    return JSON.parse(serializedState)
  } catch (err) {
    return undefined
  }
}

export const saveState = (state: any) => {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem('datamgmt-state', serializedState)
  } catch (err) {
    console.error(err)
  }
}

export const resetState = () => {
  saveState({})
}
